import Alpine from "alpinejs";
import Cookies from "js-cookie";

Alpine.data("consentBanner", () => ({
    formData: {
        name: "consentBanner form",
    },
    consents: [],
    cookieData: {
        consentAnalytics: false,
        consentMarketing: false,
    },
    scrollOverflowValue: null,
    bannerVisible: false,
    configMode: false,
    sibling: null,
    init() {
        const rawCookie = Cookies.get("consent_settings");
        if (!rawCookie) {
            this.openBanner();
        } else {
            this.configMode = true;
        }
        [...document.querySelectorAll('a[href="#consent_settings"]')].forEach((element) =>
            element.addEventListener("click", (event) => {
                event.preventDefault();
                this.openSettings();
            })
        );
    },
    destroy() {
        document.body.inert = false;
        this.releaseBody();
    },
    fixateBody() {
        document.documentElement.style.scrollbarGutter = "stable";
        this.scrollOverflowValue = document.documentElement.style.overflowY;
        document.body.style.overflowY = "hidden";
        document.documentElement.style.overflowY = "hidden";
    },
    releaseBody() {
        document.documentElement.style.overflow = this.scrollOverflowValue;
        this.scrollOverflowValue = null;
        document.body.style.overflowY = null;
    },
    openDialog() {
        this.$refs.consent.showModal();
        document.body.inert = true;
    },
    closeDialog() {
        if (this.configMode) {
            this.releaseBody();
        }
        document.body.inert = false;
        this.$refs.consent.close();
    },
    openBanner() {
        this.bannerVisible = true;
        this.sibling = this.$el.nextElementSibling;
        this.sibling.inert = true;
        this.fixateBody();
    },
    hideBanner() {
        this.sibling.inert = false;
        this.releaseBody();
        this.$nextTick(() => {
            this.bannerVisible = false;
        });
    },
    openSettings() {
        this.configMode = true;
        this.openDialog();
        if (!this.scrollOverflowValue) {
            this.fixateBody();
        }
    },
    cancel() {
        if (!this.configMode) {
            this.consents = [];
        }
        this.closeDialog();
    },
    acceptAll() {
        this.cookieData = {
            consentAnalytics: true,
            consentMarketing: true,
        };
        this.storeConsent();

        this.hideBanner();
    },
    submitForm($event) {
        $event.preventDefault();

        this.cookieData = {
            consentAnalytics: false,
            consentMarketing: false,
        };

        const acceptedConsents = this.consents.map((consent) => consent);
        acceptedConsents.forEach((consent) => {
            this.cookieData[consent] = true;
        });
        this.storeConsent();
        this.$refs.consent.close();

        if (!this.configMode) {
            this.hideBanner();
        }
        this.closeDialog();
    },
    storeConsent() {
        let cookie = this.cookieData;
        cookie["lastUpdated"] = Date.now();

        Cookies.set("consent_settings", JSON.stringify(cookie), {
            expires: 7,
            domain: window.location.host,
        });

        window.dataLayer = window.dataLayer || [];
        if (cookie.consentAnalytics) {
            window.dataLayer.push({ event: "pf.cookieconsent.analytics" });
        }
        if (cookie.consentMarketing) {
            window.dataLayer.push({ event: "pf.cookieconsent.marketing" });
        }
    },
}));
